export const NODE_NAME = 'tab_panel';
